var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { groupMarketsBySport, filterMarkets, filterOutrightsMarkets, prepareOutrightMarkets } from "../../helpers";
export var prepareMarkets = function (markets, cardConfig, specialLeagues, allEvents) {
    var marketsF = [];
    // 1. Filter outrights
    var outrightsMarkets = prepareOutrightMarkets(markets, allEvents);
    // 2. Group markets by sport and store them in an object
    var regularMarkets = filterOutrightsMarkets(false, markets, allEvents);
    var marketsBySport = groupMarketsBySport(regularMarkets, cardConfig);
    // 3. Fill empty selections for each sport
    marketsBySport = filterMarkets(marketsBySport, cardConfig, specialLeagues);
    // 4. Fill prepared markets into array
    Object.keys(marketsBySport).forEach(function (key) {
        marketsBySport[key].length && marketsF.push.apply(marketsF, __spread(marketsBySport[key]));
    });
    return __spread(marketsF, outrightsMarkets);
};
//# sourceMappingURL=prepareMarkets.js.map